/**
 * The Today compliance rule shared by the Driver tab and the Control Centre
 * Compliance card: what an open violation does to a driver's status.
 */

export type ComplianceStatus = 'compliant' | 'non-compliant' | 'at-risk' | 'unknown';

/**
 * A driver with open violations scores at least 45, plus 15 for each further
 * violation and 15 for each critical one (capped at 100, never below the
 * server's own risk score). From 70 they are non-compliant; below that a
 * driver who was compliant or could not be evaluated becomes at-risk. A driver
 * with no open violations is returned unchanged.
 */
export function applyViolationsToStatus(
  status: ComplianceStatus,
  riskScore: number | null,
  activeViolations: ReadonlyArray<{ severity?: string }>,
): { status: ComplianceStatus; riskScore: number | null } {
  if (activeViolations.length === 0) return { status, riskScore };
  const critical = activeViolations.filter((v) => v.severity === 'critical').length;
  const base = riskScore ?? 0;
  const score = Math.min(100, Math.max(base, 45 + (activeViolations.length - 1) * 15 + critical * 15));
  if (score >= 70) return { status: 'non-compliant', riskScore: score };
  if (status === 'compliant' || status === 'unknown') return { status: 'at-risk', riskScore: score };
  return { status, riskScore: score };
}
